import routes from './routes';
import { SetRoutes } from 'components';

const CouponsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default CouponsPages;
